<template>
  <video controls ref="videoRef">
    <source :src="props.data.url" type="video/mp4">
  </video>
</template>

<script setup>
  import { ref } from 'vue';
  import { Props } from './props';
  //---------------------------------------------
  const props = defineProps(Props());
  //---------------------------------------------
  const videoRef = ref(null);
  //---------------------------------------------
  defineExpose({
    play: () => videoRef.value?.play(),
    pause: () => videoRef.value?.pause(),
    isPlaying: () => !videoRef.value?.paused,
  });
</script>

<style lang="scss" scoped>
  @import './styles.scss';
</style>